import { Icon } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')({
  display: 'flex',
  position: 'fixed',
  right: '0',
  top: '0',
  width: '100%',
  margin: 5,
  zIndex: 99999,
});

export const ContentStyled = styled('div')(({ theme, showToast }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.global.gray,
  borderRadius: '5px',
  color: theme.palette.global.white,
  display: 'flex',
  height: '50px',
  justifyContent: 'space-between',
  margin: '0 10px',
  padding: '0 30px',
  width: '100%',
  transition: '0.7s ease-in-out',
  transform: showToast ? 'translateX(0%)' : 'translateX(120%)',
  opacity: showToast ? 1 : 0,
}));

export const IconStyled = styled(Icon)({
  cursor: 'pointer',
});
